var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('van-popup',{attrs:{"round":true,"close-on-click-overlay":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('img',{staticClass:"load",attrs:{"src":require("../../assets/img/productDetail/loading.gif"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }